import React, { ReactElement } from "react";
import styled from "styled-components";
import { VoorbladHoofdstuk } from "../../../.generated/rapportage/rapportagetypes";
import placeholder from "./placeholder.svg";
import { getBase64ImageType } from "../../utils";
import { Chapter } from "../components/Chapter";

type VoorbladProps = {
  voorblad: VoorbladHoofdstuk;
};

const VoorbladTitle = styled.h1`
  font-size: 40pt;
  padding-left: 20px;
  font-weight: 900;
  color: #37465e;
  line-height: 34pt;
  letter-spacing: 0.01em;
  text-align: left;
  margin-top: 60px;
  margin-bottom: 0px;
`;

const ContactInfoContainer = styled.div`
  display: flex;
  line-height: 0.5;
  margin-top: 40px;
`;

const ImageContainer = styled.div`
  height: 600px;
  width: 100%;
  position: relative;
  z-index: 1;
`;

const VoorbladImage = styled.img`
  left: 0;
  right: 0;
  width: 100%;
  max-width: 100%;
  height: 600px;
  margin-top: 25px;
  margin-left: auto;
  margin-right: auto;
  object-fit: cover;
  z-index: 1;
  border-radius: 25px;
  scale: 0.95;
`;

const KantoorInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  margin-left: 25px;
  min-width: 350px;
`;

const PersonInfoContainer = styled.div`
  display: flex;
  line-height: 0.5;

  flex-direction: column;
`;

const KantoorInfo = styled.div`
  margin-bottom: 0px;
`;

const PersonInfo = styled.div`
  margin-bottom: 0px;
`;

const Paragraph = styled.p`
  margin-bottom: 5px;
`;

export const Voorblad = ({ voorblad }: VoorbladProps): ReactElement => {
  return (
    <Chapter
      className="voorblad voorblad-chapter no-page-number skip-footer-text"
    >
      
      <VoorbladTitle id="voorblad-title" className="exclude-from-headings" data-ignore-toc={true}>
        Alstublieft
        <br />
        uw persoonlijke
        <br />
        adviesrapport
      </VoorbladTitle>

      <ImageContainer>
        {voorblad.fotoBase64 ? (
          <VoorbladImage
            src={`data:image/${getBase64ImageType(
              voorblad.fotoBase64
            )};base64,${voorblad.fotoBase64}`}
            alt="voorblad-afbeelding"
            id="voorblad-afbeelding"
          />
        ) : (
          <VoorbladImage
            src={placeholder}
            alt="voorblad-afbeelding"
            id="voorblad-afbeelding"
          />
        )}
      </ImageContainer>

      <ContactInfoContainer>
        <KantoorInfoContainer>
          <KantoorInfo>
            {voorblad.kantoorNaam && (
              <Paragraph>
                <strong>{voorblad.kantoorNaam}</strong>
              </Paragraph>
            )}
            {voorblad.adviseurNaam && (
              <Paragraph>{voorblad.adviseurNaam}</Paragraph>
            )}
            {voorblad.kantoorTelefoonnummer && (
              <Paragraph>{voorblad.kantoorTelefoonnummer}</Paragraph>
            )}
            {voorblad.kantoorEmail && (
              <Paragraph>{voorblad.kantoorEmail}</Paragraph>
            )}
            <br />
            <Paragraph>Datum: {voorblad.aanmaakDatum}</Paragraph>
            <Paragraph>Referentie: {voorblad.adviesnummer}</Paragraph>
          </KantoorInfo>
        </KantoorInfoContainer>

        <PersonInfoContainer>
          <Paragraph>
            <strong>Opgesteld voor:</strong>
          </Paragraph>
          <PersonInfo>
            {voorblad.persoon1Naam && (
              <Paragraph>{voorblad.persoon1Naam}</Paragraph>
            )}
            {voorblad.persoon2Naam && (
              <Paragraph>{voorblad.persoon2Naam}</Paragraph>
            )}
          </PersonInfo>
        </PersonInfoContainer>
      </ContactInfoContainer>
    </Chapter>
  );
};
